<template>
	<div class="modal" v-bind:class="{'is-active': showModal}">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Create a new sentence</p>
				<button class="delete" aria-label="close" @click="closeModal"></button>
			</header>
			<section class="modal-card-body">
				<div class="columns is-multiline">
					<div class="column is-8">
						<div class="field">
							<span class="heading has-text-grey-dark">Click <a href="https://www.youtube.com/watch?v=5O1LqV3E7cw&fbclid=IwAR0_eOa2g5Z2VnGG3kQZG109i-a93E2ebDZtWBovZoySIY7txrH69GqioD4" target="_blank">here</a> to watch a short tutorial</span>
							<div class="control has-icons-left has-icons-right">
                                                        <textarea id="sentence" class="is-primary textarea"
                                                                  name="sentence" v-model="sentence.text"
                                                                  v-validate="'required'"
                                                                  v-bind:class="{'input': true, 'is-danger': errors.has('sentence') }"
                                                                  type="text"
                                                                  placeholder="Type here to create a new sentence"/>
								<transition name="fade-fast">
									<span v-show="errors.has('sentence')" class="help is-danger">{{ errors.first('sentence') }}</span>
								</transition>
							</div>
						</div>
					</div>
					<div class="column is-4">
						<div class="columns is-multiline">
							<div class="column">
								<span class="heading has-text-grey-dark">Select category</span>
								<div class="field">
									<div class="control">
										<div class="select is-info is-fullwidth">
											<select v-model="sentence.category" required>
												<option v-for="category in categories" v-bind:value="category.id">
													{{category.name}}
												</option>
											</select>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="columns">
							<div class="column">
								<div class="field">
									<div class="control">
										<loading-button v-bind:loading="loading" icon="fa-plus" color="is-primary" @click="addSentence">Add</loading-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="columns is-multiline">
					<div class="column">
						<magic-words :items="magicWords" @clickOnItem="addToSentence" :open="false"/>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>
<script>

    import _ from 'lodash'

    export default {
        name: 'create-sentence-modal',
        components: {},
        props: {
            categories: {required: true, type: Array},
            magicWords: {required: true, type: Array},
            showModal: {required: true, type: Boolean},
        },
        data() {
            return {
                loading: false,
                saving: false,
                sentence: {text: '', category: null},
            }
        },
        created(){
			if(this.categories.length>0){
               this.sentence.category = this.categories[0].id;
			}
        },
        mounted(){

        },
        methods: {
            addToSentence(text){
                this.sentence.text = this.sentence.text + text;
            },
            addSentence(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        var self = this;
                        this.loading = true;
                        this.sentenceRepo.store(this.sentence).then(response => {
                            var message = response.data.message;
                            this.loading = false;
                            this.$emit('onAdded', this.helper.updateSentenceColor([response.data.data], this.categories));
                            this.$toast.success(message);
                        }).catch((response) =>{
                            this.loading = false;
                            return Promise.reject(response);
                        });
                    }
                });
            },
            closeModal(){
                this.$emit('onClose');
            },
        },
        watch: {
            categories(value) {
                if(value.length>0){
                    this.sentence.category = value[0].id;
                }
            }
        }

    }
</script>

<style lang="css" scoped>
	.card-content {
		padding-top: 2px;
		padding-bottom: 2px;
	}
	
	@media screen and (min-width: 769px) {
		.modal-content, .modal-card {
			width: 900px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/sentences/CreateSentenceModal.vue